<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  message: string
  messageClass?: string
  icon?: 'error' | 'success' | 'loading'
}>()

const fontAwesomeIcon = computed(() => {
  switch (props.icon) {
    case 'error':
      return 'fa-circle-xmark'
    case 'success':
      return 'fa-circle-check'
    case 'loading':
      return 'fa-spinner fa-spin'
    default:
      return 'fa-circle-exclamation'
  }
})
</script>

<template>
  <div class="flex items-center" v-show="message">
    <FontAwesomeIcon
      :spin="props.icon === 'loading'"
      :icon="fontAwesomeIcon"
      class="mr-2 text-xl"
      :class="messageClass"
    />
    <span class="whitespace-break-spaces text-sm font-medium">
      {{ message }}
    </span>
  </div>
</template>
